





















import { Component, Prop, Vue } from 'vue-property-decorator'
import * as t from '@/types'
import steps from '@/steps'

import { ArcDefinition, drawArc } from '@/drawArc'

interface BudgetData {
  value: number,
  tooltip: string,
  link: string,
}

@Component({
})
export default class ResultPie extends Vue {
  private currencySymbol = t.currencySymbol
  private steps = steps
  @Prop() private data!: BudgetData[]
  @Prop() private total!: number

  get totalMoney () {
    return `${this.currencySymbol}${this.total}`
  }

  get extraPaths () {
    return [
      drawArc({
        radius: 85,
        cx: 100,
        cy: 100,
        thickness: 5,
        start_angle: 0,
        end_angle: 180,
        opacity: 0.3,
        fill: 'black',
      }),
      drawArc({
        radius: 85,
        cx: 100,
        cy: 100,
        thickness: 5,
        start_angle: 180,
        end_angle: 360,
        opacity: 0.3,
        fill: 'black',
      }),
      drawArc({
        radius: 80,
        cx: 100,
        cy: 100,
        thickness: 80,
        start_angle: 0,
        end_angle: 180,
        opacity: 1,
        fill: '#f9f9f9',
      }),
      drawArc({
        radius: 80,
        cx: 100,
        cy: 100,
        thickness: 80,
        start_angle: 180,
        end_angle: 360,
        opacity: 1,
        fill: '#f9f9f9',
      })
    ]
  }

  get paths () {
    const input = this.data
    const total = input.map((b) => b.value).reduce((a, b) => a + b)
    const arcs = []
    let offset = 0
    for (const arc of input) {
      const degrees = 360 * arc.value / total
      const arcDef = drawArc({
        radius: 100,
        thickness: 20,
        start_angle: 180 + offset,
        end_angle: 180 + offset + degrees,
        opacity: 1,
        tooltip: arc.tooltip,
        link: arc.link,
      })
      arcs.push(arcDef)
      offset += degrees
    }
    return arcs
  }
}
